import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import AppInstallMenu from "./AppInstallMenu";
import { showGrade } from "../utils/textUtils";
import { formatPoint, usePointBalance } from "../features/reward/pointStore";
import { BagIcon, CoinIcon } from "../features/reward/RewardIcons";
import "./TopNavBar.css";

// 학원 로고: 주소가 있을 때만 이미지를 보여준다.
// 학생 화면에는 기본 로고를 두지 않는다. 학원이 로고를 안 걸었으면 그 자리를 비운다.
// (교사 화면은 반대로 ECHO 기본 로고를 띄운다. 우리 서비스 안이라는 표시가 필요해서다.)
// plate: 로고 뒤에 까는 판 색. 흰 글자 로고나 색 바탕 그림처럼 흰 화면에 그대로 두면 안 보이거나 네모로 떠 보이는
// 로고에만 서버가 준다(student.academy_color.plate, api/user/academy_color.py).
export const AcademyLogo = ({ src, fallback = null, plate = "" }) => {
  const [failed, setFailed] = useState(false);

  // 로고 주소가 바뀌면(재로그인 등) 실패 상태 초기화
  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return fallback;
  }

  const image = (
    <img
      src={src}
      alt="학원 로고"
      onError={() => setFailed(true)}
      className="student-nav__logo"
    />
  );

  if (!plate) {
    return image;
  }
  return (
    <span className="student-nav__logo-plate" style={{ backgroundColor: plate }}>
      {image}
    </span>
  );
};

// 포인트 · 스토어 단추. 초등 홈의 상단도 같은 단추를 쓴다(대표: 포인트 칸은 지금 모양 그대로).
export const PointStoreButton = ({ balance, isActive, onClick }) => (
  <button
    type="button"
    className={`student-nav__store${isActive ? " student-nav__store--active" : ""}`}
    onClick={onClick}
  >
    <span className="student-nav__points">
      <CoinIcon />
      {balance === null ? "…" : formatPoint(balance)}
    </span>
    <span className="student-nav__store-label">
      <BagIcon size="1em" />
      스토어
    </span>
  </button>
);

// 상단 바 한 줄에 [학원 로고] [메뉴] [학생 이름] 을 모두 둔다. teacher 상단 바와 같은 배치다.
const TopNavBar = ({ topTab, selectTab, tabList }) => {
  const { student } = useSelector((state) => state.student);
  const navigate = useNavigate();
  const location = useLocation();
  // 오른쪽 위 포인트 · 상점(2026-10-04). 누르면 상점으로 간다. 세션은 주소에 그대로 들고 간다.
  const { balance, isOpen: isStoreOpen } = usePointBalance(Boolean(student?.id));

  let gradeText = "";
  try {
    if (student?.grade !== undefined && student?.grade !== null) {
      gradeText = showGrade(student.grade);
    }
  } catch (e) {
    gradeText = "";
  }

  // 상단 메뉴 줄(오늘 과제 · 완료 과제 · 알림장)은 없앴다(2026-11-03 대표). 홈 한 화면에서 각 칸의 '전체' 로 들어간다.
  // 다른 화면에서는 왼쪽(학원 로고, 로고가 없으면 '홈')을 누르면 홈으로 돌아온다
  const isHome = topTab === tabList[0]?.name;

  return (
    <div className="student-nav">
      <div className="student-nav__inner">
        <div className="student-nav__side">
          <button type="button" className="student-nav__home" onClick={() => selectTab(tabList[0]?.name)} aria-label="홈">
            {/* 로고가 없거나 열리지 않으면 '홈' 글자(홈 화면에서는 비워 둔다) */}
            <AcademyLogo src={student?.logo_img} plate={student?.academy_color?.plate} fallback={isHome ? null : <span className="student-nav__home-text">홈</span>} />
          </button>
        </div>

        <div className="student-nav__spacer" />

        <div className="student-nav__side student-nav__side--right">
          {/* 이름을 누르면 '앱 설치' 메뉴가 열린다(AppInstallMenu.jsx) */}
          <AppInstallMenu>
            <b className="student-nav__student-name">{student?.name || ""}</b>
            {gradeText && <span className="student-nav__student-grade">{gradeText}</span>}
          </AppInstallMenu>
          {isStoreOpen && (
            <PointStoreButton
              balance={balance}
              isActive={topTab === "store"}
              onClick={() => navigate(`/store${location.search}`)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TopNavBar;
